import React, { useEffect, useRef } from "react";
import { Container, Typography } from "@mui/material";
import "./Carousel.css";

import krinvyservice1 from "../assets/images/Krinvy_drake.png";
import krinvyservice2 from "../assets/images/Krinvy_lacerte.png";
import krinvyservice3 from "../assets/images/Krinvy_proconnect.png";
import krinvyservice4 from "../assets/images/Krinvy_proseries.png";
import krinvyservice5 from "../assets/images/Krinvy_quickbooks.png";
import krinvyservice6 from "../assets/images/Krinvy_tally.png";
import krinvyservice7 from "../assets/images/Krinvy_ultratax.png";
import krinvyservice8 from "../assets/images/Krinvy_winman.png";
import krinvyservice9 from "../assets/images/Krinvy_xero.png";
import krinvyservice10 from "../assets/images/Krinvy_zohobooks.png";

const images = [
    krinvyservice1,
    krinvyservice2,
    krinvyservice3,
    krinvyservice4,
    krinvyservice5,
    krinvyservice6,
    krinvyservice7,
    krinvyservice8,
    krinvyservice9,
    krinvyservice10
];

const Carousel = () => {
    const trackRef = useRef(null);
    
    useEffect(() => {
        const track = trackRef.current;
        let animationFrameId;
        
        const animate = () => {
            if (track) {
                // Get current transform value
                const currentTransform = window.getComputedStyle(track).getPropertyValue('transform');
                const matrix = new DOMMatrix(currentTransform);
                const currentX = matrix.m41;
                
                // Reset position when we've scrolled one set of images
                if (currentX <= -track.scrollWidth / 2) {
                    track.style.transform = 'translateX(0)';
                } else {
                    // Move 1 pixel to the left
                    track.style.transform = `translateX(${currentX - 1}px)`;
                }
            }
            animationFrameId = requestAnimationFrame(animate);
        };
        
        // Start animation
        animationFrameId = requestAnimationFrame(animate);
        
        // Clean up
        return () => {
            cancelAnimationFrame(animationFrameId);
        };
    }, []);

    return (
        <Container className="tech-stack-section" maxWidth="lg">
            <Typography variant="h4" align="center" className="tech-stack-title" data-aos="fade-up">
                Our Technical Stack 
            </Typography>
            <Typography variant="h3" align="center" className="tech-stack-title1" data-aos="fade-up">
                Powering Your Growth
            </Typography>
          
            <Typography variant="h5" align="center" className="tech-stack-heading" data-aos="fade-up">
                Accounting and Taxation
            </Typography>

            <div className="tech-stack-slider">
                <div className="tech-stack-track" ref={trackRef}>
                    {images.map((img, index) => (
                        <div className="tech-stack-slide" key={`first-${index}`}>
                            <img src={img} height="150" width="150" alt={`Service ${index + 1}`} />
                        </div>
                    ))}
                    {images.map((img, index) => (
                        <div className="tech-stack-slide" key={`second-${index}`}>
                            <img src={img} height="150" width="150" alt={`Service ${index + 1}`} />
                        </div>
                    ))}
                </div>
            </div>
        </Container>
    );
};

export default Carousel;